import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import SuratMasuk from './views/SuratMasuk.vue'
import SuratMasukPimpinan from './views/SuratMasukPimpinan.vue'
import SuratKeluar from './views/SuratKeluar.vue'
import ManajemenPegawai from './views/ManajemenPegawai.vue'
import ManajemenAdmin from './views/ManajemenAdmin.vue'
import Login from './views/Login.vue'
import Agenda from './views/Agenda.vue'
import KodeSurat from './views/settings/KodeSurat.vue'
import store from './store'
import { hasAccess } from './utils/roles'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        guest: true
      }
    },
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/surat-masuk',
      name: 'surat-masuk',
      component: SuratMasuk,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/surat-masuk-pimpinan',
      name: 'surat-masuk-pimpinan',
      component: SuratMasukPimpinan,
      meta: {
        requiresAuth: true,
        roles: ['Sekpri']
      }
    },
    {
      path: '/surat-keluar',
      name: 'surat-keluar',
      component: SuratKeluar,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/manajemen-pegawai',
      name: 'manajemen-pegawai',
      component: ManajemenPegawai,
      meta: {
        requiresAuth: true,
        roles: ['Super Admin', 'Administrator']
      }
    },
    {
      path: '/manajemen-admin',
      name: 'manajemen-admin',
      component: ManajemenAdmin,
      meta: {
        requiresAuth: true,
        roles: ['Super Admin', 'Administrator']
      }
    },
    {
      path: '/agenda',
      name: 'agenda',
      component: Agenda,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/kode-surat',
      name: 'kode-surat',
      component: KodeSurat,
      meta: {
        requiresAuth: true,
        roles: ['Super Admin', 'Administrator']
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.isLoggedin) {
      next({ name: 'login' })
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.roles)) {
    if (!hasAccess(to.matched.meta.roles, store.getters.roles)) {
      next({ name: 'home' })
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (store.getters.isLoggedin) {
      next({ name: 'home' })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
